// C:\MonProjet\BBW_DELEGUER\preprod\babyworld-backoffice\babyworld-backoffice\src\pages\delegates\AssignedListDelegatesPage\columns.js

import { EyeOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import React from "react";

// Colonnes communes avec largeurs optimisées
const commonColumns = () => [
  {
    title: "Nom",
    dataIndex: "firstname",
    key: "firstname",
    fixed: 'left', 
    width: 100,
    render: (text) => <span style={{ fontWeight: 'bold' }}>{text}</span>
  },
  {
    title: "Prénom",
    dataIndex: "lastname",
    key: "lastname",
    width: 100,
  },
  {
    title: "Code",
    dataIndex: "code",
    key: "code",
    width: 120,
    ellipsis: true,
    render: (code) => <Tooltip title={code}>{code || ''}</Tooltip>,
  },
  {
    title: "Gouv.",
    dataIndex: "government",
    key: "gouvernorat",
    width: 90,
    render: (data) => <>{data?.name}</>,
  },
  {
    title: "Région",
    dataIndex: "region",
    key: "region",
    width: 90,
    render: (data) => <>{data?.name}</>,
  },
  {
    title: "Adresse",
    dataIndex: "address",
    key: "address",
    width: 150,
    ellipsis: true,
    render: (text) => <Tooltip title={text}>{text}</Tooltip>,
  },
  {
    title: "Tél.",
    dataIndex: "phoneNumber",
    key: "phone",
    width: 100,
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    width: 120,
    ellipsis: true,
    render: (text) => <Tooltip title={text}>{text}</Tooltip>,
  },
];

export const getColumnsByType = (type, navigateTo, getId) => {
  let specificColumns = [];
  
  // Conversion en tableau si ce n'est pas déjà le cas
  const typeArray = Array.isArray(type) ? type : [type];

  typeArray.forEach((t) => {
    switch (t) {
      case 1:
        specificColumns = [
          ...specificColumns,
          {
            title: "Spéc.",
            dataIndex: "doctor",
            key: "speciality",
            width: 70,
            render: (doctor) => <>{doctor?.specialty?.abreviation || doctor?.specialty?.name || 'N/A'}</>,
          },
          {
            title: "Pot.",
            dataIndex: "potential",
            key: "potential",
            width: 60,
            align: 'center',
          },
          {
            title: "Type",
            dataIndex: "doctor",
            key: "doctorType",
            width: 80,
            render: (doctor) => <>{doctor?.doctorType === 1 ? "Hosp." : "Privé"}</>,
          },
        ];
        break;
      case 2:
        specificColumns = [
          ...specificColumns,
          {
            title: "Pharmacie",
            dataIndex: "pharmacien",
            key: "pharmacy",
            width: 130,
            ellipsis: true,
            render: (data) => <Tooltip title={data?.pharmacyName}>{data?.pharmacyName}</Tooltip>,
          }
        ];
        break;
      case 3:
        specificColumns = [
          ...specificColumns,
          {
            title: "Dépot",
            dataIndex: "wholesaler",
            key: "wholesaler",
            width: 130,
            ellipsis: true,
            render: (data) => <Tooltip title={data?.companyName}>{data?.companyName}</Tooltip>,
          }
        ];
        break;
      default:
        break;
    }
  });

  return [
    ...commonColumns(),
    ...specificColumns,
    {
      title: "Action",
      key: "action",
      width: 80,
      fixed: 'right',
      render: (record) => {
        let editPath;
        const currentType = Array.isArray(type) ? type[0] : type;
        switch (currentType) {
          case 1: editPath = `/edit/médecin/${record.id}`; break;
          case 2: editPath = `/edit/pharmacie/${record.id}`; break;
          case 3: editPath = `/edit/grossiste/${record.id}`; break;
          default: editPath = `/edit/${record.type}/${record.id}`; break;
        }
        return (
          <Button
            type="link"
            size="small"
            onClick={() => navigateTo(editPath)}
            style={{ padding: 0 }}
          >
            <EyeOutlined /> Voir
          </Button>
        );
      },
    },
  ];
};